// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","dialog":"DialogTrigger__dialog--fc","dialogContent":"DialogTrigger__dialogContent--Iu","header":"DialogTrigger__header--VK"};